import { Outlet, createFileRoute } from "@tanstack/react-router";

const StreamRoute = () => <Outlet />;

export const Route = createFileRoute("/study-group/$study-group-id/stream")({
  component: StreamRoute,
});
